import React, { useState, useEffect, useCallback } from 'react';

import { Radio, FormGroup, FormControl, FormHelperText, FormControlLabel } from '@mui/material';

import ElementLabel from './ElementLabel';
import { ElementProps } from '../../../@types/forms/types';

//---------------------------------------------------------------------------------

type RadioButtonElementProps = {
  el: ElementProps;
  pageNumberScale: number;
  isFormFillerPage: boolean;
  elementContentValue?: string[] | undefined;
  handleRadioButtonChange?: (el: ElementProps, index: number) => void;
  collaboratorColor?: string;
  disabled?: boolean;
  errorMessage?: string;
};

const RadioButtonElement: React.FC<RadioButtonElementProps> = ({
  el,
  pageNumberScale,
  elementContentValue,
  isFormFillerPage,
  handleRadioButtonChange,
  collaboratorColor,
  disabled = false,
  errorMessage,
}) => {
  const [value, setValue] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (elementContentValue && elementContentValue.length > 0) {
      setValue(elementContentValue[0]);
    } else {
      setValue(undefined);
    }
  }, [elementContentValue]);

  const createClickHandler = useCallback(
    (index: number, optionLabel: string) => () => {
      if (handleRadioButtonChange) {
        handleRadioButtonChange(el, index);
        setValue(optionLabel);
      }
    },
    [handleRadioButtonChange, el]
  );

  return (
    <>
      {el.formGroupOptions && el.formGroupOptions?.length > 0 && (
        <FormControl
          component="fieldset"
          variant="standard"
          error={!!errorMessage}
          sx={{
            backgroundColor: collaboratorColor,
            borderRadius: 1,
            px: 1,
            width: '100%',
          }}
          id={el.id}
        >
          <FormGroup>
            {el.formGroupOptions.map((option, index) => (
              <FormControlLabel
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  lineHeight: `${Math.round(el.fontSize * pageNumberScale)}px`,
                  // m: 0,
                  // p: 0
                }}
                key={`${el.id}-${index + 1}`}
                control={
                  <Radio
                    sx={{
                      fontSize: `${el.fontSize * pageNumberScale}`,
                      m: 0,
                      p: 0,
                      pr: 1,
                    }}
                    checked={value === option.label}
                    name={option.label}
                    disabled={disabled}
                    onClick={createClickHandler(index, option.label)}
                  />
                }
                label={
                  <ElementLabel
                    el={el}
                    label={option.label}
                    pageNumberScale={pageNumberScale}
                    asChildEl
                  />
                }
              />
            ))}
          </FormGroup>
          {errorMessage && <FormHelperText>{errorMessage}</FormHelperText>}
        </FormControl>
      )}

      {(!el.formGroupOptions || el.formGroupOptions?.length === 0) && (
        <ElementLabel
          el={el}
          label={el.label}
          pageNumberScale={pageNumberScale}
          collaboratorColor={collaboratorColor}
        />
      )}
    </>
  );
};

export default RadioButtonElement;
